import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MitraArea from '../components/MitraArea';

const MitraAreaPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Cek apakah ada session/token di localStorage
    const authToken = localStorage.getItem('auth_token') || localStorage.getItem('access_token');
    
    // Jika tidak ada token, redirect ke halaman login
    if (!authToken) {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  // Cek lagi sebelum render untuk mencegah flash
  const authToken = localStorage.getItem('auth_token') || localStorage.getItem('access_token');
  
  // Jika tidak ada token, return null atau loading state
  if (!authToken) {
    return null;
  }

  return (
    <MitraArea />
  );
};

export default MitraAreaPage;
